import { Theme } from '@mui/material/styles';
import { TimeSignalClassification } from 'graphql/types';

export enum TIMELINE_EVENT_TYPE {
  INBOX = 'Inbox',
  ACCEPTED = 'Accepted',
  PRIVATE = 'Private',
  TRASH = 'Trash'
}

export const getTimelineEventInfo = (
  theme: Theme,
  classification: TimeSignalClassification
): { color: string; eventType: TIMELINE_EVENT_TYPE } => {
  switch (classification) {
    case TimeSignalClassification.Accepted:
      return {
        color: theme.palette.notesLabel.accepted,
        eventType: TIMELINE_EVENT_TYPE.ACCEPTED
      };
    case TimeSignalClassification.Unclassified:
      return {
        color: theme.palette.notesLabel.inbox,
        eventType: TIMELINE_EVENT_TYPE.INBOX
      };
    case TimeSignalClassification.Private:
      return {
        color: theme.palette.notesLabel.private,
        eventType: TIMELINE_EVENT_TYPE.PRIVATE
      };
    case TimeSignalClassification.Trash:
      return {
        color: theme.palette.notesLabel.trash,
        eventType: TIMELINE_EVENT_TYPE.TRASH
      };
  }
};
